module.exports = __webpack_public_path__ + "static/media/ayala-white-logo.885fa9a0.svg";